/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ErrorMessage } from '../model/errorMessage';
// @ts-ignore
import { TopOfBookSource } from '../model/topOfBookSource';
// @ts-ignore
import { TopOfBookSourceRequest } from '../model/topOfBookSourceRequest';
// @ts-ignore
import { TopOfBookSourceUpdateRequest } from '../model/topOfBookSourceUpdateRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface CreateTopOfBookSourceRequestParams {
  topOfBookSourceRequest: TopOfBookSourceRequest;
}

export interface FindTopOfBookSourcesRequestParams {
  /** Top of book source type for filtering */
  type?:
    | 'BINANCE_SPOT'
    | 'BINANCE_PERPETUAL'
    | 'BYBIT_SPOT'
    | 'BYBIT_PERPETUAL'
    | 'OKX_SPOT'
    | 'OKX_PERPETUAL'
    | 'AGGREGATE'
    | 'MULTIPLY'
    | 'DIVIDE'
    | 'PERP_SPOT_CHAINING'
    | 'LIQUIDITY_PROVIDER'
    | 'COINBASE_PERPETUAL'
    | 'KRAKEN_SPOT'
    | 'COINBASE_SPOT';
}

export interface UpdateTopOfBookSourceRequestParams {
  topOfBookSourceUpdateRequest: TopOfBookSourceUpdateRequest;
}

@Injectable({
  providedIn: 'root',
})
export class TopOfBookSourceControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Create top of book source
   * @endpoint post /v1/top-of-book-source
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public createTopOfBookSource(
    requestParameters: CreateTopOfBookSourceRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<TopOfBookSource>;
  public createTopOfBookSource(
    requestParameters: CreateTopOfBookSourceRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<TopOfBookSource>>;
  public createTopOfBookSource(
    requestParameters: CreateTopOfBookSourceRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<TopOfBookSource>>;
  public createTopOfBookSource(
    requestParameters: CreateTopOfBookSourceRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const topOfBookSourceRequest = requestParameters?.topOfBookSourceRequest;
    if (topOfBookSourceRequest === null || topOfBookSourceRequest === undefined) {
      throw new Error(
        'Required parameter topOfBookSourceRequest was null or undefined when calling createTopOfBookSource.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/top-of-book-source`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<TopOfBookSource>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: topOfBookSourceRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Find top of book sources
   * @endpoint get /v1/top-of-book-source
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public findTopOfBookSources(
    requestParameters?: FindTopOfBookSourcesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<TopOfBookSource>>;
  public findTopOfBookSources(
    requestParameters?: FindTopOfBookSourcesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<TopOfBookSource>>>;
  public findTopOfBookSources(
    requestParameters?: FindTopOfBookSourcesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<TopOfBookSource>>>;
  public findTopOfBookSources(
    requestParameters?: FindTopOfBookSourcesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const type = requestParameters?.type;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'type',
      <any>type,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/top-of-book-source`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<TopOfBookSource>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Update top of book source
   * @endpoint put /v1/top-of-book-source
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public updateTopOfBookSource(
    requestParameters: UpdateTopOfBookSourceRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<TopOfBookSource>;
  public updateTopOfBookSource(
    requestParameters: UpdateTopOfBookSourceRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<TopOfBookSource>>;
  public updateTopOfBookSource(
    requestParameters: UpdateTopOfBookSourceRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<TopOfBookSource>>;
  public updateTopOfBookSource(
    requestParameters: UpdateTopOfBookSourceRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const topOfBookSourceUpdateRequest = requestParameters?.topOfBookSourceUpdateRequest;
    if (topOfBookSourceUpdateRequest === null || topOfBookSourceUpdateRequest === undefined) {
      throw new Error(
        'Required parameter topOfBookSourceUpdateRequest was null or undefined when calling updateTopOfBookSource.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/top-of-book-source`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<TopOfBookSource>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: topOfBookSourceUpdateRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
